// extracted by mini-css-extract-plugin
module.exports = {"header":"UserDashboard_header__Yh68A","overview-section":"UserDashboard_overview-section__3Vuou","training-section":"UserDashboard_training-section__3E29m"};